import { createBrowserRouter, Outlet } from 'react-router-dom';
import { MainLayout } from '../layouts/MainLayout';
import HomeScreen from '../screens/HomeScreen';
import ProfileScreen from '../screens/ProfileScreen';
import AssetDetailScreen from '../screens/AssetDetailScreen';
import PortfolioStrategyScreen from '../screens/PortfolioStrategyScreen';
import ErrorScreen from '../screens/ErrorScreen'; 

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout><Outlet /></MainLayout>,
    children: [
      {
        path: '/',
        element: <HomeScreen />,
      },
      {
        path: '/profile',
        element: <ProfileScreen />,
      },
      {
        path: '/asset/:id',
        element: <AssetDetailScreen />,
      },
      {
        path: '/portfolio-strategy',
        element: <PortfolioStrategyScreen />,
      },
      {
        path: '/error',
        element: <ErrorScreen />,
      },
    ],
  },
]); 